import { useEffect, useState } from 'react';

const useFilterAggregationValues = ({ data, filterValues }) => {
  const [stateValues, setStateValues] = useState(data);
  const [prop, setProp] = useState('');

  useEffect(
    () => {
      if (!stateValues) return setStateValues(data);

      const lastChangedFilter = filterValues?.[prop];

      if (!data) return;

      const newOptions = data[prop];
      const currentOptions = stateValues?.[prop];

      if (lastChangedFilter === null || lastChangedFilter === '') {
        return setStateValues(prevState => ({
          ...data,
          [prop]: newOptions
        }));
      }

      setStateValues(prevState => ({
        ...data,
        [prop]: currentOptions
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, prop, filterValues]
  );

  return [stateValues, setStateValues, setProp, prop];
};

export default useFilterAggregationValues;
